import React, { useEffect, useState } from 'react';
import type { AnimatedText2Definition } from '../AnimatedText2';
import AnimatedText2 from '../AnimatedText2';
import type { ContentfulComponentDefinition } from '../ContentfulComponent';

export type AnimatedTextGroupDefinition = ContentfulComponentDefinition & {
  texts: AnimatedText2Definition[],
  baseDelay?: number,
  stepDelay?: number,
  cycleDuration?: number,
  internal: {
    type: 'ContentfulComponentAnimatedGroup',
  }
};

type AnimatedTextGroupProps = {
  content: AnimatedTextGroupDefinition,
  className?: string;
  loop?: boolean
};

const AnimatedTextGroup = ({
  content,
  className = '',
  loop = false,
}:AnimatedTextGroupProps) => {
  const {
    texts, baseDelay = 0.2, stepDelay = 0.1, cycleDuration = 1,
  } = content;
  const [cycleKey, setCycleKey] = useState(0);

  useEffect(() => {
    if (!cycleDuration || !loop) {
      return undefined;
    }

    const timer = setTimeout(() => {
      setCycleKey((prev) => prev + 1);
    }, cycleDuration * 1000);

    return () => {
      clearTimeout(timer);
    };
  }, [cycleKey, cycleDuration, loop]);

  return (
    <div key={cycleKey} className={`flex flex-col gap-2 ${className}`}>
      {texts.map((item, index) => (
        <AnimatedText2
          key={item.id}
          content={{
            ...item,
            animationSettings: {
              ...item.animationSettings,
              delay: baseDelay + index * stepDelay,
              loop,
            },
          }}
          className="relative"
        />
      ))}
    </div>
  );
};

export default AnimatedTextGroup;
